/* unplugin-vue-components disabled */import script from "./screen_mg.vue?vue&type=script&lang=ts&setup=true"
export * from "./screen_mg.vue?vue&type=script&lang=ts&setup=true"

import "./screen_mg.vue?vue&type=style&index=0&id=00215ac2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00215ac2"]])

export default __exports__